export const DEFAULT_CHAIN = process.env.REACT_APP_DEFAULT_CHAIN;
export const DEFAULT_RPC = process.env.REACT_APP_DEFAULT_RPC;


export const contract = {
  1: {
    MULTICALL_ADDRESS: "0x5e227ad1969ea493b43f840cff78d08a6fc17796",
    BARC_ADDRESS: "0x590619F44e1550CccD6F7778aE73947050Aec22B",
    WETH_ADDRESS: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
    GLDN_ADDRESS: "0xFeeB4D0f5463B1b04351823C246bdB84c4320CC2",
    BARC_LP_ADDRESS: "0x2D9E02e149963718113C864253E479A8451eeF89",
    DIVIDEND_ADDRESS: "0xB2Fa5795B6fDa35c262E66e23712FbA891c9eE3a"
  },
  5: {
    MULTICALL_ADDRESS: "0xA78B1c073483655DC5eCf568CFef12Ab9b30338C",
    BARC_ADDRESS: "0x30133a2cf12f5bb1ee614e9886f57e3af288e9cc",
    WETH_ADDRESS: "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
    BARC_LP_ADDRESS: "0xf61ED098d8597Da51D8892a8A1400C5E33cd78c5",
    DIVIDEND_ADDRESS: "0x1D05b0f5B76641D4E8407e894718C1CF0f4cfFa2"
  }
}

// export const networkQuery = 'ethereum';
export const networkQuery = 'goerli';
export const afterDate = '2024-01-01';
export const dateFormat = "%Y-%m-%d";
export const api_key = 'BQYe06FtBSsC3egmFbtBKZrWfLFf8A0G';


export const transactionQuery = `query ($network: EthereumNetwork!, $token: String!, $limit: Int!, $offset: Int!,$after: ISO8601DateTime) {
  ethereum(network: $network) {
    dexTrades(
      options: {desc: ["block.height", "tradeIndex"], limit: $limit, offset: $offset}
      date: {after: $after}
      baseCurrency: {is: $token}
    ) {
      block {
        timestamp {
          time(format: "%Y-%m-%d %H:%M:%S")
        }
        height
      }
      tradeIndex
      protocol
      exchange {
        fullName
      }
      smartContract {
        address {
          address
          annotation
        }
      }
      buyAmount
      buyCurrency {
          address
          symbol
      }
      
      base_amount_usd: baseAmount(in: USD)
      sellAmount
      sellCurrency {
          address
          symbol
      }
      quote_amount_usd: quoteAmount(in: USD)
      transaction {
        hash
      }
    }
  }
}`;


export const userTransactionQuery = `query ($network: EthereumNetwork!,  $user: String!  , $token: String!, $limit: Int!, $offset: Int!, $after: ISO8601DateTime) {
  ethereum(network: $network) {
    dexTrades(
      options: {desc: ["block.height", "tradeIndex"], limit: $limit, offset: $offset}
      date: {after: $after}
      baseCurrency: {is: $token}
    ) {
      block {
        timestamp {
          time(format: "%Y-%m-%d %H:%M:%S")
        }
        height
      }
      tradeIndex
      protocol
      exchange {
        fullName
      }
      smartContract {
        address {
          address
          annotation
        }
      }
      buyAmount
      buyCurrency {
          address
          symbol
      }
      
      base_amount_usd: baseAmount(in: USD)
      sellAmount
      sellCurrency {
          address
          symbol
      }
      quote_amount_usd: quoteAmount(in: USD)
      transaction(txSender: {is: $user}) {
        hash
      }
      maker {
        address
      }
    }
  }
}
`